import React, { useEffect, useState } from "react";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import {
  differenceInYears,
  differenceInMonths,
  parseISO,
  isValid,
} from "date-fns";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { useLocation } from "react-router-dom";

const OnBenchProjectReport = () => {
  const dispatch = useDispatch();

  const location = useLocation();

  const passedState = location.state;

  const [benchProject, setbenchProject] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [countData, setCountData] = useState("");
  const [apiStatus, setApiStatus] = useState(undefined);

  useEffect(() => {
    dispatch(
      updateNavbarHeading(
        passedState ? passedState?.text : "On Bench Project Report"
      )
    );
  }, []);

  const columns = {
    Code: { text: "EMP ID", visible: true },
    EmployeeName: { text: "Employee", visible: true },
    Email: { text: "Email", visible: true },
    ReportingHead: { text: "Manager", visible: true },
    PrimarySkillName: { text: "Primary Skills", visible: true },
    SecondarySkillName: { text: "Secondary Skills", visible: true },
    lastToDate: { text: "Total Exp.", align: "center", visible: true },
    lastFromDate: { text: "Rel. Exp.", align: "center", visible: true },
    MostRecentDate: {
      text: "On Bench",
      align: "center",
      visible: true,
    },
    WeekdayDifference: {
      text: "#Days",
      align: "center",
      visible: true,
    },
    GrossAmount: { text: "Gross Salary", align: "end", visible: true },
    CurrentStatus: { text: "Status", visible: false },
  };

  useEffect(() => {
    fetchbenchProject();
  }, []);

  const [totalGrossSal, setTotalGrossSal] = useState(0);
  const fetchbenchProject = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}rom-report/4`);
      if (response.status === 200) {
        setApiStatus(response.status);
        const benchProject = response?.data?.header;

        const dateConvert = benchProject.map((item) => {
          const from = item.lastFromDate ? parseISO(item.lastFromDate) : null;
          const to = item.lastToDate ? parseISO(item.lastToDate) : null;
          const mostRecent = item.MostRecentDate
            ? parseISO(item.MostRecentDate)
            : null;

          let relevantExperience = "";
          let benchExperience = "";

          if (from && to && isValid(from) && isValid(to)) {
            let years = differenceInYears(to, from);
            let months = differenceInMonths(to, from) % 12;

            if (months < 0) {
              years -= 1;
              months += 12;
            }

            relevantExperience = `${years} yr ${months} m`;
          }

          if (from && mostRecent && isValid(from) && isValid(mostRecent)) {
            let years = differenceInYears(mostRecent, from);
            let months = differenceInMonths(mostRecent, from) % 12;

            if (months < 0) {
              years -= 1;
              months += 12;
            }

            benchExperience = `${years} yr ${months} m`;
          }

          return {
            ...item,
            lastFromDate: relevantExperience,
            GrossAmount: Number(item?.GrossAmount).toFixed(2),
            lastToDate: benchExperience, // Add this field to store MostRecentDate - lastFromDate calculation
          };
        });
        const totalGrossSalary = Array.isArray(dateConvert)
          ? dateConvert.reduce((sum, employee) => {
              return sum + (parseFloat(employee?.GrossAmount) || 0);
            }, 0)
          : 0;

        setTotalGrossSal(totalGrossSalary);

        console.log("totalGrossSalary", totalGrossSalary);

        setbenchProject(dateConvert);
        setCountData(response.data.header.length);
      } else {
        console.error(
          "Failed to fetch Course. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Course:", error);
    }
  };

  const ReadOnlyValues = [
    {
      label: "Total Employee",
      value: countData || 0,
    },
    {
      label: "Total Gross Salary",
      value: `₹ ${Number(totalGrossSal || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`,
    },
  ];

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={benchProject}
              columns={columns}
              itemsPerPage={8}
              ReadOnlyValues={ReadOnlyValues}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              showIcon1={true}
              showIcon2={false}
              showIcon3={false}
              isSorting={true}
              showIcon4={true}
              showIcon5={false}
              isActionRequired={false}
              isFilterRequired={false}
              isCheckBoxRequired={false}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon2: <i class="bi bi-trash-fill icons"></i>,
                Icon3: <i class="bi bi-eye-fill icons"></i>,
                Icon4: <i class="bi bi-person-plus icons"></i>,
                Icon4Text: "Create Employee",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default OnBenchProjectReport;
